exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal {\n  width: 100%;\n  filter: none;\n  max-width: 750px;\n  margin: 20px auto 0;\n  will-change: transform, opacity; }\n  .modal--small {\n    max-width: 400px; }\n  .modal__wrapper {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 300;\n    padding: 20px;\n    position: fixed;\n    overflow-y: auto;\n    will-change: opacity;\n    background-color: rgba(0, 0, 0, 0.5); }\n\n:host /deep/ .card-body {\n  overflow-x: inherit; }\n\n:host /deep/ .modal--overflow .card-body {\n  overflow-y: auto;\n  max-height: calc(100vh - 170px); }\n\n@media only screen and (min-width: 768px) {\n  .modal {\n    margin: 40px auto 0; }\n    .modal__wrapper {\n      padding: 40px 20px 20px; }\n  :host /deep/ .modal--overflow .card-body {\n    max-height: calc(100vh - 210px); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/modal/modal.component.scss
// module id = 56
// module chunks = 0 1